import state from './moduleStatementState.js'
import mutations from './moduleStatementMutations.js'
import actions from './moduleStatementActions.js'
import getters from './moduleStatementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
